/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const Organization = Loadable(lazy(() => import("sections/organization/index")));
const AdminUsers = Loadable(lazy(() => import("sections/organization/users/")));
const AccountProfile = Loadable(lazy(() => import("sections/organization/users/profile")));
const AdminRoles = Loadable(lazy(() => import("sections/organization/roles")));
const AdminSettings = Loadable(lazy(() => import("sections/organization/settings")));

const organizationRoutes = [
    {
        path: "admin",
        children: [
            {
                path: "profile",
                element: <AccountProfile />,
            },
            {
                path: "users",
                element: <AdminUsers />,
            },
            {
                path: "roles",
                element: <AdminRoles />,
            },
            {
                path: "settings",
                element: <AdminSettings />,
            },
        ],
    },
    {
        path: "organization",
        element: <Organization />,
    },
];

export { organizationRoutes };
